export default __webpack_public_path__ + "static/fav-img01-40e423538b344479de4fc1e34962423b.jpg";